require('./bootstrap');



import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import vSelect from 'vue-select'



import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'




import VuePersianDatetimePicker from 'vue-persian-datetime-picker';


import Multiselect from 'vue-multiselect'


import Snotify, {
  SnotifyPosition
} from 'vue-snotify' // 1. Import Snotify
const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}
// window.axios = require('axios');

Vue.component('multiselect', Multiselect)

Vue.component('v-select', vSelect)


Vue.component('pagination', require('./views/pages/pagination.vue').default);




import ScrollLoader from 'vue-scroll-loader'

Vue.use(ScrollLoader)


Vue.use(CKEditor);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)





Vue.use(Snotify, options)
Vue.config.performance = true

Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

Vue.use(VuePersianDatetimePicker, {
  name: 'custom-time-picker',
  props: {
    format: 'YYYY-MM-DD HH:mm:ss',
    displayFormat: 'jYYYY-jMM-jDD HH:mm',
    // inputFormat: 'YY-MM-DD HH:mm',
    // format: 'jYYYY/jMM/jDD',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'تاریخ را انتخاب کنید',
    // altFormat: 'yy-MM-DD HH:mm',
    // color: '#00acc1',
    color: '#00acc1',
    autoSubmit: true,
    //...
    //... And whatever you want to set as default
    //...
  }
});



Vue.use(require('vue-jalali-moment'));

import moment from "moment-jalaali";
// import fa from "moment/src/locale/fa";


/// temp // must to correct
// if('APP_LANG' != 'en'){
moment.locale("fa");
moment.loadPersian();
// }

Vue.use(moment)


// import VueI18n from 'vue-i18n'
//
// Vue.use(VueI18n)
import i18n from './local'










import AudioRecorder from 'vue-audio-recorder'

Vue.use(AudioRecorder)



import VueRecord from '@codekraft-studio/vue-record'

Vue.use(VueRecord)





// import _ from 'lodash';
// import lodash from 'lodash'
// window._ = require('lodash');
// Vue.use(lodash, { name: '_' , lodash: lodash })
// const range = _.range(1, 3); // [1, 2]
// const random = _.random(0, 5); // an integer between 0 and 5
// Object.defineProperty(Vue.prototype, '$_', { value: _ });


Vue.prototype.$appName = 'سایان'
Vue.prototype.$API = 'http://'
Vue.prototype.$personel = 'کارمندان'
Vue.prototype.$lead = 'سرنخ'
Vue.prototype.$opportunity = 'فرصت'
Vue.prototype.$client = 'مشتری'  // check variable
// Vue.prototype.$client = ''
Vue.prototype.$vendor = 'تامین‌کننده'
Vue.prototype.$sale = 'فروش'   // check variable
// Vue.prototype.$sale = ''
Vue.prototype.$buy = 'خرید'
Vue.prototype.$buyer = 'خریدار'
Vue.prototype.$seller = 'فروشنده'
Vue.prototype.$business = 'شرکت'
Vue.prototype.$curency= 'ریال'


if (process.env.VUE_APP_CLIENT_ID)
  Vue.prototype.$clientId= process.env.VUE_APP_CLIENT_ID
else
  Vue.prototype.$clientId= '0'

if (process.env.VUE_APP_COMPANY_ID)
  Vue.prototype.$companyId= process.env.VUE_APP_COMPANY_ID
else
  Vue.prototype.$companyId= '0'



Vue.prototype.$saleActive =  true  // check variable


// Vue.config.sale =  'خرید/فروش'   // check variable
// Vue.config.sale =  'خرید'




import httpPlugin from "./https"
Vue.use(httpPlugin)



new Vue({
  el: '#app',
    i18n,
    router,
    store,
    icons,
  template: '<App/>',
  components: {
    App
  }
})
